module.exports = __webpack_public_path__ + "img/banner-home1.57524fe6.webp";